import {
  Form,
  FormSubmitButton,
  NavigationContext,
  SnackbarContext,
  useEventCallback,
  UserContext,
} from '@eas/common-web';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';

import { FormattedMessage } from 'react-intl';
import { useStyles } from './login-styles';
import { NameField, PasswordField } from './login-fields';
import { useContext } from 'react';
import { loginUser } from './login-api';
import React from 'react';
import { Messages } from '@enums';

const useShowSnackbarError = () => {
  const { showSnackbar } = useContext(SnackbarContext);

  return () => {
    const message = Messages.Auth.LOGIN.ERROR;
    showSnackbar(...message);
  };
};

const INITIAL_VALUES = {
  username: '',
  password: '',
};

type FormData = typeof INITIAL_VALUES;

const meCall = async () => {
  const response = await fetch('/api/tapis/me');
  return response;
};

export function Login() {
  const classes = useStyles();
  const { navigate } = useContext(NavigationContext);

  const { reload } = useContext(UserContext);

  const showSnackbarError = useShowSnackbarError();

  const onSubmit = useEventCallback(
    async ({ username, password }: FormData) => {
      const env = process.env.NODE_ENV;
      if (!env) return;

      try {
        await loginUser(username, password, env);
        await reload();
      } catch (e) {
        // NOTE: Duplicated logic as in useUser from common-web
        const response = await meCall();

        try {
          await response.json();
          await reload();

          navigate('/', true);
        } catch (e) {
          showSnackbarError();
        }
      }
    }
  );

  return (
    <div className={classes.page}>
      <Paper className={classes.paper}>
        <Form onSubmit={onSubmit} editing initialValues={INITIAL_VALUES}>
          <div className={classes.content}>
            <Grid container>
              <Grid item>
                <Typography variant="h1">
                  <FormattedMessage
                    id="TAPIS__LOGIN__TITLE"
                    defaultMessage="Vítejte zpátky"
                  />
                </Typography>
                <Typography variant="subtitle1">
                  <FormattedMessage
                    id="TAPIS__LOGIN__SUBTITLE"
                    defaultMessage="Pokračujte přihlášením!"
                  />
                </Typography>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item md sm xs>
                <NameField />
              </Grid>
            </Grid>
            <Grid container>
              <Grid item md sm xs>
                <PasswordField />
              </Grid>
            </Grid>
            <Grid container justify="center">
              <FormSubmitButton
                variant="contained"
                color="primary"
                type="submit"
                className={classes.button}
                fullWidth
              >
                <FormattedMessage
                  id="TAPIS__LOGIN__LOGIN"
                  defaultMessage="Přihlásit se"
                />
              </FormSubmitButton>
            </Grid>
          </div>
        </Form>
      </Paper>
    </div>
  );
}
